module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm5.772 18H10.236c-1.06 0-1.92-.938-1.922-2 .002-1.062.862-2 1.922-2h11.536c1.06 0 1.922.94 1.922 2-.002 1.062-.862 2-1.922 2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/minus-2.js
// module id = 1283
// module chunks = 14